module.exports = __webpack_public_path__ + "static/media/404-raumfahrt.487b7752.png";